"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryContent = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./LibraryContent.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var LibraryContent = function (_a) {
    var libraryItems = _a.libraryItems;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var filteredItems = (0, lodash_1.cloneDeep)(libraryItems).filter(function (item) { return !((!!item.featureFlag && !usingFeature(item.featureFlag)) || item.hide); });
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", wrap: true, className: styles.libraryContentWrapper }, filteredItems.map(function (item, key) {
        return (react_1.default.createElement("div", { className: styles.buttonCardWrapper, key: key },
            react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: function () { return item.onClick(); }, className: styles.buttonCard },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s" },
                    react_1.default.createElement(item.icon, { className: styles.icon, size: icons_1.IconSize.Medium }),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "xxs" },
                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.itemName }, item.displayName),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.itemDescription }, item.description))))));
    })));
};
exports.LibraryContent = LibraryContent;
